import { MarkupItemModel, QuantityCounterInputModel, SelectInputModel, TextInputModel } from '@libs/form/models';

export const ProductDetailData: MarkupItemModel = {
  type: 'markup',
  content: '',
};

export const ShoppingListInfoData: MarkupItemModel = {
  type: 'markup',
  content: 'Vorhandene Einkaufsliste wählen oder eine neue erstellen',
};

export const TitleInfoData: MarkupItemModel = {
  type: 'markup',
  content: 'Artikel der Einkaufsliste hinzufügen',
};

export const ProductCounterData: QuantityCounterInputModel = {
  type: 'quantityCounter',
  label: '',
  name: 'productQuantity',
  value: 100,
};

export const ShoppingListInputData: SelectInputModel = {
  type: 'select',
  name: 'shoppingList',
  label: 'Einkaufsliste',
  hint: '*Pflichtfeld',
  attributes: {
    required: true,
  },
  options: [],
};

export const ShoppingListNameInputData: TextInputModel = {
  label: 'Listenname',
  name: 'newListName',
  type: 'text',
  attributes: {
    required: true,
    disabled: true,
  },
};
